import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["filtersInput", "sortInput", "filters", "sort", "closeButton", "showButton", "form"]

  connect() {
  }

  clickFilterOption(e) {
    if(e.target.classList.contains("active")){
      e.target.classList.remove("active");
    }else {
      e.target.classList.add("active");
    }
    this.checkActiveOptions();
  }

  setLocation(position) {
    document.getElementById("longitude").value = position.coords.longitude;
    document.getElementById("latitude").value = position.coords.latitude;
    let option = document.getElementById("distance");
    let children = option.parentNode.childNodes;
    for (const node of children) {
      if(node.localName == "span" && node.classList.contains("active")){
        node.classList.remove("active");
      }
    }
    option.classList.add("active");
    document.getElementById("showButton").classList.add("active");
    document.getElementById("closeButton").classList.remove("active");
  }

  showLocationError(error) {
    switch(error.code) {
      case error.PERMISSION_DENIED:
         console.log("User denied the request for Geolocation.");
        break;
      case error.POSITION_UNAVAILABLE:
         console.log("Location information is unavailable.");
        break;
      case error.TIMEOUT:
         console.log("The request to get user location timed out.");
        break;
      case error.UNKNOWN_ERROR:
         console.log("An unknown error occurred.");
        break;
    }
  }

  clickSortOption(e) {
    if(e.target.classList.contains("active")){
      e.target.classList.remove("active");
    } else if(e.target.id == "distance"){
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.setLocation, this.showLocationError);
        } else { 
          alert("Geolocation is not supported by this browser.");
        }
    } else {
      let children = e.target.parentNode.childNodes;
      for (const node of children) {
        if(node.localName == "span" && node.classList.contains("active")){
          node.classList.remove("active");
        }
      }
      e.target.classList.add("active");
    }
    this.checkActiveOptions();
  }

  checkActiveOptions() {
    for (const node of this.filtersTarget.childNodes){
      if(node.localName == "span" && node.classList.contains("active")){
        this.showButtonTarget.classList.add("active");
        this.closeButtonTarget.classList.remove("active");
        return;
      }
    }

    for (const node of this.sortTarget.childNodes){
      if(node.localName == "span" && node.classList.contains("active")){
        this.showButtonTarget.classList.add("active");
        this.closeButtonTarget.classList.remove("active");
        return;
      }
    }

    this.showButtonTarget.classList.remove("active");
    this.closeButtonTarget.classList.add("active");
  }

  clearFilters() {
    for (const node of this.filtersTarget.childNodes){
      if(node.localName == "span" && node.classList.contains("active")){
        node.classList.remove("active");
      }
    }

    for (const node of this.sortTarget.childNodes){
      if(node.localName == "span" && node.classList.contains("active")){
        node.classList.remove("active");
      }
    }

    this.showButtonTarget.classList.remove("active");
    this.closeButtonTarget.classList.add("active");
  }

  formSubmit() {
    let filters = [];
    for (const node of this.filtersTarget.childNodes){
      if(node.localName == "span" && node.classList.contains("active")){
        filters.push(node.id);
      }
    }
    this.filtersInputTarget.value = filters.join();

    for (const node of this.sortTarget.childNodes){
      if(node.localName == "span" && node.classList.contains("active")){
        this.sortInputTarget.value = node.id;
        break;
      }
    }

    document.getElementById("filter-modal").classList.remove("is-open");
    this.formTarget.requestSubmit();
  }

  closeModal(){
    document.getElementById("filter-modal").classList.remove("is-open");
  }
}
